<ng-container *ngIf="state$ | async; let state">
    <ng-container *ngIf="validity$ | async; let validity">
        <div class="zas-width-wide">
            <h1>Unterschriften</h1>
            <div
                *ngIf="
                    !state.document ||
                    state.document.dirty ||
                    state.document.beingBuilt
                "
            >
                <div class="waiting">
                    <span class="icon-loop spinning"></span>
                    <span class="message">Dokument wird erstellt</span>
                </div>
            </div>
            <div class="zas-row">
                <ng-container *ngFor="let field of state.document.signatures">
                    <button
                        type="button"
                        class="zas-button"
                        (click)="currentField = field"
                    >
                        <span
                            [class.icon-hook]="esignService.isSigned(field)"
                            [class.icon-accordeon-minus]="
                                !esignService.isSigned(field)
                            "
                        ></span>
                        <span class="button-label"
                            >{{ field.metadata.Label }} (Seite
                            {{ field.metadata.Page }})</span
                        >
                    </button>
                    <span class="horizontal-spacer"></span>
                </ng-container>
            </div>
            <div *ngIf="currentField">
                <div
                    *ngFor="
                        let field of state.document.signatures;
                        trackBy: trackSignature
                    "
                    style="touch-action: none"
                >
                    <esignature
                        [field]="field"
                        [signatureScale]="signatureScale"
                        [store]="store"
                        [hidden]="field.index !== currentField.index"
                    ></esignature>
                </div>
            </div>
            <div
                class="zas-hr-blue-7"
                style="width: 1533px; margin: 3rem 0 3rem 0"
            ></div>
            <div class="zas-row">
                <button
                    *ngIf="!state.cp.IsFinished"
                    type="button"
                    class="zas-button-thin zas-button-cta-abschluss"
                    [disabled]="!state.esignView.canFinalize"
                    (click)="finalizeProtocol(state.cp.ConsultationProcess)"
                >
                    <span class="icon-icon-cta"></span>
                    <span class="button-label"
                        >Beratungsdokumentation abschließen</span
                    >
                </button>
                <span class="horizontal-spacer"></span>
                <button type="button" class="zas-button" [routerLink]="['..']">
                    <span class="button-label">Zurück</span>
                </button>
            </div>
        </div>
    </ng-container>
</ng-container>

<finalizing-modal></finalizing-modal>
